/**
 * State management for transcript module
 */

// Transcript data
export let currentTranscript = null;
export let currentLanguage = 'en';
export let availableLanguages = [];

// DOM elements
export let transcriptContainer = null;
export let languageButtonsContainer = null;

/**
 * Reset all state
 */
export function resetState() {
	currentTranscript = null;
	currentLanguage = 'en';
	availableLanguages = [];
}

/**
 * Set DOM elements
 */
export function setContainerElements(container, langContainer) {
	transcriptContainer = container;
	languageButtonsContainer = langContainer;
}

/**
 * Clear DOM elements
 */
export function clearContainerElements() {
	transcriptContainer = null;
	languageButtonsContainer = null;
}

/**
 * Set current transcript
 */
export function setCurrentTranscript(transcript) {
	currentTranscript = transcript;
}

/**
 * Set current language
 */
export function setCurrentLanguage(lang) {
	currentLanguage = lang;
}

/**
 * Set available languages
 */
export function setAvailableLanguages(languages) {
	availableLanguages = languages;
}

